<template>
  <v-container
    class="
      m-search-bar-container
      d-flex
      pa-0
      align-center align-self-center align-content-center
    "
  >
    <v-text-field
      ref="search"
      v-model="keyword"
      placeholder="Search"
      clearable
      color="mp-secondary"
      prepend-inner-icon="mdi-magnify"
      @click:clear="clearSearch"
      @blur="onSearchBlur"
      @focus="onSearchFocus"
      @keyup.enter="submitSearch"
      @keyup="onSearchKeyup"
      :disabled="isDisabled"
      :class="{ 'focused-underline': isFocused }"
    />
  </v-container>
</template>
<script>
export default {
  name: "MSearchBar",
  data() {
    return {
      keyword: "",
      isDisabled: false,
      isFocused:false
    };
  },
  watch: {
    $route (to, from) {
      this.setSearchText()
      this.enableDisableSearch()
    }, 
  },
  methods: {
    setSearchText() {
      if (!this.$route.query.name) {
        this.keyword = "";
      } else {
        this.keyword = this.$route.query.name;
      }
    },
    clearSearch: function () {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$emit("event");
      }

      this.keyword = "";
      let query = { ...this.$route.query };
      if (query.name) {
        delete query.name;
        delete query.search;
        this.$router.replace({ query });
      }

      this.$refs.search.blur();
    },
    submitSearch() {
      if(this.$route.name && (this.$route.name == 'All_contacts' || this.$route.name =='List_contacts') && this.keyword.length < 2){
        this.$store.commit('ui/snackbar', {
          message: "Search key should be atleast two characters.",
          type: 'error',
        })
        return;
      }
      /** Initial Values */
      let {accountId} = this.$route.params
      let query = {
        name: this.keyword,
        search: "true"
      }

      /** Find Path on basis route meta */
      let search = this.$route.meta.search
      if(!search){
        search = {
          path: this.$route.path
        }
      }
      else if("path" in search && (!("absolute" in search) || !search.absolute)){
        /** Add accountId for relative path  */
        let path = search.path;
        if(!path.startsWith('/')){
          path = `/${path}`;
        }
        if(!path.startsWith(`/accounts/${accountId}`) && process.env.VUE_APP_PRODUCT == 'Marketing'){
          path = `/accounts/${accountId}${path}`;
        }
        search.path = path;
      }
      
      /** add query params */
      search.query = query
      
      this.$router.push(search);
    },
    onSearchFocus() {
      this.isFocused = true;
    },
    onSearchBlur() {
      this.isFocused = false;
    },
    onSearchKeyup() {
      return this.keyword === "" ? this.clearSearch() : false;
    },
    enableDisableSearch() {
      this.isDisabled = false;
      if (
        "meta" in this.$route &&
        "search" in this.$route.meta &&
        this.$route.meta.search === false
      ) {
        this.isDisabled = true;
      }
    },
  },
};
</script>
<style>
.m-search-bar-container .v-input__slot {
  margin: 18px 0 0 0 !important;
}
.focused-underline .v-input__control {
  border-bottom: 2px solid #03b6fc;
  transition: border-bottom 0.2s linear;
}

.v-input__control {
  border-bottom: none;
}
</style>
